import React, { useState } from 'react';
import { BsArchiveFill, BsBarChartFill, BsCardList, BsChatDotsFill, BsGrid1X2Fill, BsListCheck, BsMailbox2, BsPeopleFill, BsPersonDash, BsPersonFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom'; // Import for navigation
import logo from '../../images/dc_logo.png';
import './Sidebar.css';
import { RiFeedbackFill, RiFilePdfFill } from 'react-icons/ri';
import { GrDocument, GrUser } from 'react-icons/gr';
import { BookAudioIcon, BookCheckIcon } from 'lucide-react';

function Sidebar({ openSidebarToggle, OpenSidebar }) {
  const [activeLink, setActiveLink] = useState(''); // State to track active link

  const navigate = useNavigate(); // Utilize useNavigate hook

  const handleClick = (link) => {
    setActiveLink(link); // Update active link on click
  
    // Render appropriate component based on link
    switch (link) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'menu':
        navigate('/menu');
        break;
      case 'mentors':
        navigate('/manage-career-coaches');
        break;
        break;
      case 'experts':
        navigate('/manage-professionals');
        break;
      case 'users':
        navigate('/users');
        break;
      case 'meetings':
        navigate('/meetings');
        break;
      case 'push-email':
        navigate('/push-email');
        break;
      case 'seminar':
        navigate('/seminar');
        break;
      case 'seminar-bookings':
        navigate('/seminar-bookings');
        break;
      case 'feedback':
        navigate('/feedback');
        break;
      // case 'help':
      //   navigate('/admin-panel/help');
      //   break;
      default:
        navigate('/');
    }
  };

  return (
    <aside id="sidebar" className={openSidebarToggle ? "sidebar-responsive" : ""}>
      <div className='sidebar-title'>
        <div className='sidebar-brand'>
          <div id='eatzap-logo'>
            <img className='logo-img' src={logo} alt="eatzap logo" />
          </div>
          <div id='eatzap-text'>
            IDEAL PURSUITS
          </div>
        </div>
        <span className='icon close_icon' onClick={OpenSidebar}>X</span>
      </div>

      <ul className='sidebar-list'>
        <li className={`sidebar-list-item ${activeLink === 'dashboard' ? 'active' : ''}`} onClick={() => handleClick('dashboard')}>
          <a>
            <BsGrid1X2Fill className='icon' /> Dashboard
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'mentors' ? 'active' : ''}`} onClick={() => handleClick('mentors')}>
          <a>
            <BsCardList className='icon' /> Career Coaches
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'experts' ? 'active' : ''}`} onClick={() => handleClick('experts')}>
          <a>
            <BsCardList className='icon' /> Professionals
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'users' ? 'active' : ''}`} onClick={() => handleClick('users')}>
          <a>
            <GrUser className='icon' /> Users
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'meetings' ? 'active' : ''}`} onClick={() => handleClick('meetings')}>
          <a>
            <BsPeopleFill className='icon' /> Meetings
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'push-email' ? 'active' : ''}`} onClick={() => handleClick('push-email')}>
          <a>
            <BsMailbox2 className='icon' /> Push Email
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'seminar' ? 'active' : ''}`} onClick={() => handleClick('seminar')}>
          <a>
            <BookAudioIcon className='icon' /> Seminar
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'seminar-bookings' ? 'active' : ''}`} onClick={() => handleClick('seminar-bookings')}>
          <a>
            <BookCheckIcon className='icon' /> Seminar Bookings
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'feedback' ? 'active' : ''}`} onClick={() => handleClick('feedback')}>
          <a>
            <RiFeedbackFill className='icon' /> Feedback
          </a>
        </li>
        {/* <li className={`sidebar-list-item ${activeLink === 'daily-reports' ? 'active' : ''}`} onClick={() => handleClick('daily-reports')}>
          <a>
            <RiFilePdfFill className='icon' /> Daily Reports
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'analytics' ? 'active' : ''}`} onClick={() => handleClick('analytics')}>
          <a>
            <BsBarChartFill className='icon' /> Analytics
          </a>
        </li>
        <li className={`sidebar-list-item ${activeLink === 'admins' ? 'active' : ''}`} onClick={() => handleClick('admins')}>
          <a>
            <BsPersonFill className='icon' /> Admins
          </a>
        </li> */}
      </ul>
    </aside>
  );
}

export default Sidebar;